/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { facilitiesStyles } from './location-facilities.styles';
import { IFacility } from '../../api/locations/types';

type PropTypes = {
    facilities?: IFacility[];
};

export const LocationFacilities: FC<PropTypes> = ({ facilities }) => {
    const intl = useIntl();

    if (!facilities || facilities.length === 0) {
        return null;
    }

    const getFacilityName = (facility: IFacility): string => {
        const locale = intl.locale as keyof typeof facility.translation;
        return facility.translation[locale] || facility.translation.en || facility.name;
    };

    return (
        <div css={facilitiesStyles.container}>
            {facilities.map(facility => (
                <div key={facility._id} css={facilitiesStyles.facilityTag}>
                    {getFacilityName(facility)}
                </div>
            ))}
        </div>
    );
};
